export default "__VITE_ASSET__DSz1jGbp__"